import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import AmaLogo from "@/components/app/AmaLogo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { CheckCircle2, KeyRound, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [form, setForm] = useState({ new_password: "", confirm_password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) return setError("La conferma password non corrisponde.");
    setSubmitting(true); setError(null);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: form.new_password, confirm_password: form.confirm_password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (e2) {
      setError(e2?.response?.data?.detail || "Errore durante il ripristino.");
    } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "linear-gradient(160deg,#0a0a2e 0%, #3a0e5e 55%, #6f42c1 100%)" }}>
      <Card className="ama-card border-0 max-w-md w-full shadow-2xl" data-testid="reset-password-page">
        <CardHeader>
          <div className="mb-3"><AmaLogo size={38} /></div>
          <CardTitle className="font-heading">Reimposta password</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {done ? (
            <Alert data-testid="reset-done" className="bg-emerald-50 border-emerald-200">
              <CheckCircle2 className="w-4 h-4 text-emerald-700" />
              <AlertTitle>Password reimpostata</AlertTitle>
              <AlertDescription>Puoi ora accedere con le nuove credenziali. Sarai reindirizzato al login.</AlertDescription>
            </Alert>
          ) : (
            <form onSubmit={submit} className="space-y-3">
              <div>
                <Label>Nuova password</Label>
                <Input data-testid="reset-new" type="password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} required />
                <div className="text-xs text-slate-500 mt-1">Almeno 12 caratteri, con maiuscola, minuscola, numero e carattere speciale.</div>
              </div>
              <div>
                <Label>Conferma password</Label>
                <Input data-testid="reset-confirm" type="password" value={form.confirm_password} onChange={(e) => setForm({ ...form, confirm_password: e.target.value })} required />
              </div>
              {error && <Alert variant="destructive"><AlertDescription>{error}</AlertDescription></Alert>}
              <Button data-testid="reset-submit" type="submit" disabled={submitting} className="w-full ama-btn-primary rounded-full">
                {submitting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <KeyRound className="w-4 h-4 mr-2" />}
                Imposta nuova password
              </Button>
            </form>
          )}
          <div className="text-center pt-2 border-t">
            <Link to="/login" className="text-xs text-slate-500 hover:text-[#d63384]">Torna al login</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
